import baseParser from '../parsers/base';

export const base = (value: any, truncateAt?: number) => {
	value = baseParser(value);

	if (Array.isArray(value)) value = value.join(', ');

	// React will not execute tags and will render the &lt;/&gt; literally
	// if (typeof value === 'string') {
	// 	value = value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
	// }

	if (value != null && truncateAt && value.length > truncateAt) {
		value = value.substr(0, truncateAt) + '...';
	}

	return value;
};

export default base;
